/** Get book owners */
const apiGetOwners = () => `/api/litres/owners/`; // GET


const apiGetPrices = "/api/litres/prices/";
const apiReferralsLogin = "/api/litres/referrals/";
const apiReferralsLitresAccount = "/api/litres/referrals/ots/";
const apiReferralsLitresRoyalty = "/api/litres/referrals/royalty/";
export { apiGetOwners, apiGetPrices, apiReferralsLogin, apiReferralsLitresAccount, apiReferralsLitresRoyalty };